import ReactFullpage from '@fullpage/react-fullpage';
import {
  About,
  Hero,
  Intro,
  Partners,
  Roadmap,
  Scene,
  ScreenController,
  Target,
  Team,
  Token,
  Works,
} from 'components';
import './Home.scss';

const Home: React.FC = (props) => {
  return (
    <div className="home-page">
      {/* <ReactFullpage
        scrollingSpeed={800}
        licenseKey={''}
        render={() => (
          <ReactFullpage.Wrapper>
            <div
              className="section"
            >
              <div style={{ minHeight: '150vh', background: 'linear-gradient(to Bottom, green, black)' }}></div>
            </div>
            <div
              className="section"
            >
              <div style={{ minHeight: '150vh', background: 'linear-gradient(to Bottom, blue, red)' }}></div>
            </div>
            <div
              className="section"
            >
              <div style={{ minHeight: '150vh', background: 'linear-gradient(to Bottom, violet, green)' }}></div>
            </div>
          </ReactFullpage.Wrapper>
        )}
      /> */}
      <ScreenController>
        <Hero />
        <About />
        <Target />
        <Token />
        <Works />
        <Partners />
        <Team />
        <Roadmap />
      </ScreenController>
      <Scene />
      <Intro />
    </div>
  );
};

export default Home;
